import axios from 'axios';
import { baseUrl } from '../Infrastructure/Config/ApiConfig';
import { token } from './AuthService';

const base = `${baseUrl()}Admin`;

export const getAllClientsAsync = async (pageNumber) => {
    const response = await axios.get(`${base}/GetAllClients/${pageNumber}`, {
        headers: {
            'Authorization': `Bearer ${token()}`
        }
    });
    return response.data;
}

export const getClientByIdAsync = async clientId => {
    const response = await axios.get(`${base}/GetClientById/${clientId}`, {
        headers: {
            'Authorization': `Bearer ${token()}`
        }
    });
    return response.data;
}

export const getClientByUrlTokenAsync = async urlToken => {
    const response = await axios.get(`${base}/GetClientByUrlToken/${urlToken}`, {
        headers: {
            'Authorization': `Bearer ${token()}`
        }
    });
    return response.data;
}

export const getStatsAsync = async () => {
    const response = await axios.get(`${base}/GetStats`, {
        headers: {
            'Authorization': `Bearer ${token()}`
        }
    });
    return response.data;
}

export const pauseClientAsync = async data => {
    const response = await axios.post(`${base}/PauseClient`, data, {
        headers: {
            'Authorization': `Bearer ${token()}`
        }
    });
    return response.data;
}

export const unpauseClientAsync = async data => {
    const response = await axios.post(`${base}/UnPauseClient`, data, {
        headers: {
            'Authorization': `Bearer ${token()}`
        }
    });
    return response.data;
}

export const deleteClientAsync = async data => {
    const response = await axios.post(`${base}/DeleteClient`, data, {
        headers: {
            'Authorization': `Bearer ${token()}`
        }
    });
    return response.data;
}

export const archiveClientAsync = async data => {
    const response = await axios.post(`${base}/ArchiveClient`, data, {
        headers: {
            'Authorization': `Bearer ${token()}`
        }
    });
    return response.data;
}


export const updateMaxLearnersAsync = async data => {
    const response = await axios.post(`${base}/UpdateMaxLearners`, data, {
        headers: {
            'Authorization': `Bearer ${token()}`
        }
    });
    return response.data;
}

export const assignLearnerClaimAsync = async data => {
    const response = await axios.post(`${base}/AssignLearnerClaim`, data, {
        headers: {
            'Authorization': `Bearer ${token()}`
        }
    });
    return response.data;
}

export const assignAdminClaimAsync = async data => {
    const response = await axios.post(`${base}/AssignAdminClaim`, data, {
        headers: {
            'Authorization': `Bearer ${token()}`
        }
    });
    return response.data;
}

export const getClientUsersAsync = async (pageNumber, clientId) => {
    const response = await axios.get(`${base}/GetAllUsersForClient/${pageNumber}/${clientId}`, {
        headers: {
            'Authorization': `Bearer ${token()}`
        }
    });
    return response.data;
}

export const clientListAsync = async () => {
    const response = await axios.get(`${base}/ClientList`, {
        headers: {
            'Authorization': `Bearer ${token()}`
        }
    });
    return response.data;
}

export const createGroupAsync = async (group) => {
    const response = await axios.post(`${base}/client/group`, group, {
        headers: {
            'Authorization': `Bearer ${token()}`
        }
    });
    return response.data;
}
// User management endpoints
export const getClientUsersWithDetailsAsync = async (clientId) => {
    const response = await axios.get(`${base}/GetClientUsersWithDetails/${clientId}`, {
        headers: {
            'Authorization': `Bearer ${token()}`
        }
    });
    return response.data;
}

export const changeUserRoleAsync = async (data) => {
    const response = await axios.post(`${base}/ChangeUserRole`, data, {
        headers: {
            'Authorization': `Bearer ${token()}`
        }
    });
    return response.data;
}

export const getClientCoursesDropdownAsync = async (clientId) => {
    const response = await axios.get(`${base}/GetClientCoursesDropdown/${clientId}`, {
        headers: {
            'Authorization': `Bearer ${token()}`
        }
    });
    return response.data;
}

export const getClientCourseProgressAsync = async (clientId, courseId, pageNumber = 1) => {
    const response = await axios.get(`${base}/GetClientCourseProgress?clientId=${clientId}&courseId=${courseId}&pageNumber=${pageNumber}`, {
        headers: {
            'Authorization': `Bearer ${token()}`
        }
    });
    return response.data;
}

export const getClientConfigAsync = async (clientId) => {
    const response = await axios.get(`${base}/GetClientConfig/${clientId}`, {
        headers: {
            'Authorization': `Bearer ${token()}`
        }
    });
    return response.data;
}

export const updateClientConfigAsync = async (data) => {
    const response = await axios.post(`${base}/UpdateClientConfig`, data, {
        headers: {
            'Authorization': `Bearer ${token()}`
        }
    });
    return response.data;
}

export const getClientReminderSettingsAsync = async (clientId) => {
    const response = await axios.get(`${base}/GetClientReminderSettings/${clientId}`, {
        headers: {
            'Authorization': `Bearer ${token()}`
        }
    });
    return response.data;
}

export const updateClientReminderSettingsAsync = async (data) => {
    const response = await axios.post(`${base}/UpdateClientReminderSettings`, data, {
        headers: {
            'Authorization': `Bearer ${token()}`
        }
    });
    return response.data;
}

export const getClientReportSettingsAsync = async (clientId) => {
    const response = await axios.get(`${base}/GetClientReportSettings/${clientId}`, {
        headers: {
            'Authorization': `Bearer ${token()}`
        }
    });
    return response.data;
}

export const updateClientReportSettingsAsync = async (data) => {
    const response = await axios.post(`${base}/UpdateClientReportSettings`, data, {
        headers: {
            'Authorization': `Bearer ${token()}`
        }
    });
    return response.data;
}

export const previewClientReportAsync = async (clientId, period) => {
    const response = await axios.get(`${base}/PreviewClientReport?clientId=${clientId}&period=${period}`, {
        headers: {
            'Authorization': `Bearer ${token()}`
        }
    });
    return response.data;
}